import toxto from "../assets/img/toxto.png";
import Button from "../components/Button";
import { useRouter } from "../hooks/useRouter";

function Welcome() {
  const router = useRouter();

  return (
    <div className="flex flex-col items-center justify-between min-h-screen p-8">
      <div className="flex flex-col justify-center flex-grow">
        <h1 className="mb-6 text-xl font-bold text-center">
          Touch Export Tool
        </h1>
        <img
          src={toxto}
          alt="Logo Touch Export Tool"
          className="h-56 rounded-lg"
        />
      </div>
      <Button
        onClick={() => {
          router.push("/app");
        }}
      >
        Start
      </Button>
    </div>
  );
}

export default Welcome;
